// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"6c487f48","455":"2ed339be","977":"efc14070"}[chunkId] + ".chunk.js";
};